import { render, staticRenderFns } from "./NoticiasCarouselComponent.vue?vue&type=template&id=ecc22d16&scoped=true"
import script from "./NoticiasCarouselComponent.vue?vue&type=script&lang=ts"
export * from "./NoticiasCarouselComponent.vue?vue&type=script&lang=ts"
import style0 from "./NoticiasCarouselComponent.vue?vue&type=style&index=0&id=ecc22d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc22d16",
  null
  
)

export default component.exports